import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!newPrice || !currentPrice) return;

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
        // --- Re-apply override price after morph ---
  setTimeout(() => {
    // Find the closest variant-picker and call updateOverridePrice
    const variantPicker = this.closest('[data-product]')?.querySelector('variant-picker');
    
    if (variantPicker && typeof variantPicker.updateOverridePrice === 'function') {
      variantPicker.updateOverridePrice();
    }
  }, 0);
    }

    // Toggle native preorder badge using inventory data from the variant event.
    const vd = event.detail?.resource;  // MUST be .resource not .data
    if (vd && typeof vd.inventory_management !== 'undefined') {
      const isPreorder =
        vd.inventory_management === 'shopify' &&
        Number(vd.inventory_quantity) <= 0 &&
        vd.inventory_policy === 'continue';
      this.dataset.isPreorder = isPreorder ? 'true' : 'false';
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
